import * as types from '../constants/types';
import { makeAuthorizedRequest } from '../utilities/rest';
import { doneLoading, startLoading } from './loading';
import * as globals from '../constants/globals';

export const queryFromSearchParameters = (paramArray) => {
  let query = '';

  if (typeof paramArray === 'object' && paramArray.length) {
    for (const param of paramArray) {
      const keys = Object.keys(param);

      for (const key of keys) {
        const value = param[key];
        const encodedValue = encodeURIComponent(value);

        query += `${key}=${encodedValue}&`;
      }
    }
  }

  return query.slice(0, -1);
};

function fetchUsersSuccess(payload) {
  return {
    type: types.FETCH_USERS_SUCCESS,
    payload,
    loaded: true,
    error: null,
  };
}

function fetchUsersFailure(error) {
  return {
    type: types.FETCH_USERS_FAILED,
    error,
  };
}

const deDupeUserList = (users) => {
  const userSet = new Map();
  users.forEach((u) => {
    if (!userSet.get(u.user_id)) {
      userSet.set(u.user_id, u);
    }
  });
  return Array.from(userSet.values());
};

export function fetchUsers(paramArray, spin) {
  const doLoading = spin !== false;
  return async (dispatch, getState) => {
    if (doLoading) {
      dispatch(startLoading('Loading list of users ...'));
    }

    try {
      const state = getState();
      const user = state.login.user;
      const requests = [];

      let encodedUsersQuery = queryFromSearchParameters(paramArray);
      encodedUsersQuery = encodedUsersQuery.length ? `/${user.user_id}/search-for-users?${encodedUsersQuery}` : '';
      requests.push(makeAuthorizedRequest(`${globals.API_URL}/user${encodedUsersQuery}`, 'GET', dispatch));

      let encodedRecAreaUsersQuery = '';
      if (state.facilityInfo && state.facilityInfo.location) {
        const path = state.facilityInfo.location.location_path;
        const recArea = path.find((l) => l.location_type === 'Rec Area');
        if (recArea) {
          encodedRecAreaUsersQuery = queryFromSearchParameters([recArea]);
        }

        if (encodedRecAreaUsersQuery.length) {
          encodedRecAreaUsersQuery = `/${user.user_id}/search-for-users?${encodedRecAreaUsersQuery}`;
          requests.push(makeAuthorizedRequest(`${globals.API_URL}/user${encodedRecAreaUsersQuery}`, 'GET', dispatch));
        }
      }

      const responses = await Promise.all(requests);

      if (responses.length === 2) {
        responses[0].users = responses[0].users.concat(responses[1].users);
      }
      responses[0].users = deDupeUserList(responses[0].users);

      dispatch(fetchUsersSuccess(responses[0]));
    } catch (error) {
      console.log(error);
      dispatch(fetchUsersFailure(error));
    }

    if (doLoading) {
      dispatch(doneLoading());
    }
  };
}

export function fetchUsersClear() {
  return {
    type: types.FETCH_USERS_CLEAR,
  };
}
